export { default } from './ContextAnimationInformationQuizStep';
